<template>
  <div>
    <div class="right">
      更新时间:2023年12月17日<br />
      生效时间:2023年12月17日
    </div>
    <p>
      <span
        >大好婚礼非常重视用户的隐私和个人信息的保护，安徽省大好信息咨询有限公司将按照法律规定，采取相应的安全保护措施，尽全力保护您的隐私和个人信息。鉴于以上，安徽省大好信息咨询有限公司制定了本《隐私政策》并在此提示您：</span
      >
    </p>
    <div class="SharedList" @click="SharedList">第三方个人信息共享清单</div>
    <!-- <div class="SharedList" @click="behavior">
      授权前行为清单
    </div> -->
    <div class="SharedList" @click="PersonalInformationList">个人信息收集表</div>

    <p>
      <span>本政策适用于大好婚礼平台提供的所有产品及服务.</span
      ><strong
        >如安徽省大好信息咨询有限公司及关联公司的产品和服务中（例如使用大好婚礼账号登录大好婚礼网站）使用了大好婚礼平台提供的产品或服务但未设独立隐私政策的，则本隐私政策同样适用于该部分产品或服务。如安徽省大好信息咨询有限公司及关联公司提供的产品和服务中设有独立隐私政策的，则相应的产品或服务适用相应独立的隐私政策。</strong
      >
    </p>
    <p>
      <span
        >您使用或在安徽省大好信息咨询有限公司更新本隐私政策后（安徽省大好信息咨询有限公司会及时提示您更新的情况）继续使用安徽省大好信息咨询有限公司的产品或服务，即意味着您同意本隐私政策（含后续更新版本）的内容。</span
      >
    </p>
    <p>
      <span
        >在使用安徽省大好信息咨询有限公司的产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体标识的条款，在确认充分理解并同意后开始使用相关产品或服务。</span
      >
    </p>
    <!-- <p>
      <strong
        >以上信息包括但不限于基本信息（包括但不限于自然人的姓名、出生日期、性别、住址、个人电话号码、邮箱 ）、身份信息（包括但不限于身份证件号码、个人生物识别信息 ）、网络身份标识信息（包括但不限于系统账号、IP地址、邮箱地址及与前述有关的密码 ）、个人上网记录（包括但不限于网站浏览记录、软件使用记录、点击记录 ）、个人常用设备信息（包括但不限于硬件型号、设备地址、操作系统类型、设备序列号、设备IMEI、IMSI、mac地址、android
        id ）、软件安装列表、通讯录、照片 。</strong
      >
    </p> -->
    <p>
      <strong>1、用户信息的收集和使用</strong>
    </p>
    <p>
      <span
        >1.1
        您已知悉且同意，为实现向您提供安徽省大好信息咨询有限公司的产品及/或服务的功能时，您须授权安徽省大好信息咨询有限公司收集、使用必要的信息。如您拒绝提供相应信息，您将无法正常使用安徽省大好信息咨询有限公司的产品及/或服务。</span
      >
    </p>

    <p>
      <strong
        >特别提示：因安徽省大好信息咨询有限公司向您提供的产品和服务种类众多，且不同用户选择使用的具体产品、服务存在差异，故对应功能及收集使用的个人信息类型、范围
        会有所不同，请以具体的产品、服务功能为准。</strong
      >
    </p>
    <p>
      <strong
        >安徽省大好信息咨询有限公司承诺严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：
      </strong>
    </p>
    <p>
      <strong> 1.1.1安徽省大好信息咨询有限公司 收集的信息 </strong>
    </p>
    <!-- <p>
      <strong>
    （一）与个人身份无关的信息：   </strong>
    </p>
    <p>
      为了向您提供更针对性的婚礼推荐服务，当您使用安徽省大好信息咨询有限公司的服务时，安徽省大好信息咨询有限公司 收集和汇总诸如用户的来源途径、访问顺序 信息，例如记录使用服务的每个用户的来源途径、浏览器软件 。
    </p>
    <p> -->

    <strong>有关个人身份的信息： </strong>
    <p> <strong>当您使用服务时，安徽省大好信息咨询有限公司 收集和汇总或要求您提供有关个人身份的信息，</strong></p>
    <p> <strong>例如个人身份证明、生日、籍贯、性别、个人电话号码；</strong></p>
    <p> <strong>网络身份标识信息（包括系统账号、IP地址、电子邮箱地址）；</strong></p>
    <p> <strong>个人上网记录和日志信息（包括软件使用记录、点击记录、操作日志）；</strong></p>
    <p> <strong>
      为识别您的设备id并预防恶意程序及反作弊，提高服务安全性，保障运营质量及效率，我们会收集您的设备信息（
      IMEI/androidID/IDFA/OPENUDID/GUID，mac 地址，您安装的应用信息会运行中的进程信息）</strong>
    </p>
    <p>为对大好婚礼错误异常进行监控，以及对平台进行优化升级，我们将搜集手机应用软件运行异常信息</p>
    <p>
      为实现运行故障报错及分析和解决在使用大好婚礼过程中所遇到的问题，<strong>我们将收集您的设备信息（包括设备型号、GUID，设备MAC地址、操作系统类型）浏览和操作记录
      为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的硬件型号、操作系统版本号、设备标识符（Android如IMEI/MEID、AndroidID、OAID、IMSI、SIM卡信息（如ICCID）、GAID、、硬件序列号（SN）；网络设备硬件地址（设备MAC地址）、硬件序列号、IP 地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志数据。
      </strong>
    </p>
    <p>为了更好的体验线下实体门店的服务，我们将搜集您的设备位置信息.</p>
    <p>
      安徽省大好信息咨询有限公司收集您的信息主要是为了您和其他用户能够更容易和更满意地使用服务。安徽省大好信息咨询有限公司的目标是向所有的互联网用户提供安全、有趣及有教益的上网经历。而这些信息有助于安徽省大好信息咨询有限公司实现这一目标。
    </p>
    <strong>您理解并同意：</strong>
    <p>
      1、安徽省大好信息咨询有限公司致力于打造各种各样的产品和服务以满足您的需求，因安徽省大好信息咨询有限公司向您提供的产品和服务种类众多且不同用户选择使用的具体产品/服务范围存在差异，相应的，基本/附加功能及收集使用的个人信息类型、范围
      会有所区别，请以具体的产品/服务功能为准；
    </p>
    <p>
      2、为给您带来更好的产品和服务体验，安徽省大好信息咨询有限公司在持续努力改进安徽省大好信息咨询有限公司的技术，随之安徽省大好信息咨询有限公司
      会不时推出新的或优化后的功能，
      需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，安徽省大好信息咨询有限公司将通过更新本政策、弹窗、页面提示方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。在此过程中，如果您有任何疑问、意见或建议的，您可通过安徽省大好信息咨询有限公司在APP中载明的各种联系方式与安徽省大好信息咨询有限公司联系，安徽省大好信息咨询有限公司会尽快为您作出解答。
    </p>
    <p>
      3、安徽省大好信息咨询有限公司在您使用服务过程中获取的您的信息。您在使用安徽省大好信息咨询有限公司的服务时，为了解产品适配性、识别账号异常状态，向您提供更契合您需求的页面内容和搜索结果，安徽省大好信息咨询有限公司收集、汇总、记录的信息，包括：
      <strong>
      1）位置信息：为了便捷您发现周边合理范围内的门店，以及给您查询您所在城市的婚礼服务信息，安徽省大好信息咨询有限公司会基于您的地理位置为您提供服务。当您开启设备定位功能并使用安徽省大好信息咨询有限公司基于位置提供的相关服务时，安徽省大好信息咨询有限公司会收集和使用您的地理位置，以实现安徽省大好信息咨询有限公司为您提供婚礼信息的目的。安徽省大好信息咨询有限公司会使用有关技术对您的实际位置进行定位，这些技术包括IP地址、GPS以及能够提供相关信息的WLAN接入点、蓝牙和基站传感器技术。安徽省大好信息咨询有限公司会收集您当时所处的地理位置，并将您各时段的位置信息进行关联以判断您的行踪轨迹。
      您可在您的设备中查看位置信息权限状态，并可自行决定随时的开启或关闭。您理解并同意，您关闭定位功能，停止安徽省大好信息咨询有限公司对您的地理位置信息的收集，您将
      无法使用安徽省大好信息咨询有限公司基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。
      2）设备信息：安徽省大好信息咨询有限公司会根据您在软件安装及使用中的具体操作，在后台状态下获取了您的MAC信息，目的是为了向您提供更契合您需求的页面内容和搜索结果，在后台状态下获取您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符、使用的移动应用和其他软件信息软硬件特征信息）、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站传感器信息）。
      </strong>
    </p>
    <!-- <p>

      <strong>
        为了给您带来更好的产品和服务体验，安徽省大好信息咨询有限公司会持续改进安徽省大好信息咨询有限公司的技术，更新安徽省大好信息咨询有限公司的产品与服务，不时推出新的或优化后的功能， 需要收集、使用新的个人信息或变更个人信息使用目的或方式。如发生以上情形，安徽省大好信息咨询有限公司将通过更新本政策、弹窗、大好婚礼平台页面提示 方式另行向您详细说明，为您提供自主选择同意的方式，在征得您明示同意后再开始收集、使用。
      </strong>
    </p> -->
    <p>
      <span>1.2 大好婚礼将在以下具体功能场景中所收集、使用您的用户信息，包括： </span>
    </p>
    <p><strong>（一）会员与账户管理</strong></p>
    <p>
      <span
        >1.2.1
        注册信息：您注册大好婚礼帐号或登录使用大好婚礼平台提供的服务时，您至少需要向安徽省大好信息咨询有限公司提供手机号码及根据您提供的手机号码校验您本人身份所收到的验证码；如您拒绝提供上述信息，您将无法注册或登录大好婚礼账号。
      </span>
    </p>
    <p>
      <span
        >1.2.2 个人信息：如果您选择提供真实姓名、头像、昵称、真实婚期、性别、家乡、年龄、个人简介
        非注册必须的个人资料，其中如您提供昵称和头像的，您的昵称、头像将公开显示。</span
      >
    </p>
    <p>
      <span
        >如您选择对另一半发出注册邀请共享信息，需向大好婚礼平台提供对方的手机号码，并选取通过QQ、微信、短信方式部分或全部渠道分享邀请注册信息。安徽省大好信息咨询有限公司将根据您提供的信息和渠道核实您邀请的另一半的信息以便绑定你们的大好婚礼账号并共享电子请帖、记账本
        信息。</span
      >
    </p>
    <p>
      <span
        >1.2.3
        授权登录：如您选择绑定QQ、微信第三方账号，安徽省大好信息咨询有限公司将根据您的选及授权从QQ、微信第三方处获取您的第三方账户信息（QQ头像、昵称、及其他页面提示的信息），并与您的大好婚礼账户进行绑定。绑定后，您可以与更多朋友分享足迹和体验。同时您下次登录大好婚礼退出后可以直接使用上述第三方账号信息登录，无需再次验证手机短信。安徽省大好信息咨询有限公司将在您授权范围内使用您的相关信息。</span
      >
    </p>
    <p>
      <span
        >1.2.4
        商家信息：如您申请注册成为大好婚礼商家，您需主动向安徽省大好信息咨询有限公司提供身份信息及/或企业信息及必要的行业许可信息，并授权安徽省大好信息咨询有限公司通过支付宝公司或企查查公司处认证您的上述信息，用于您身份获取资格的核验、登记、公示及其他安徽省大好信息咨询有限公司明确告知的目的。</span
      >
    </p>
    <!-- <p>
      <strong>（二）帮助您实现下单及订单管理</strong>
    </p>
    <p>
      <span
        >2.2.10
        订单信息：您在使用过程中，订购商品或服务时，安徽省大好信息咨询有限公司会通过系统为您生成相应订单，您需要提供相应的收件人信息（包括收件人姓名、收货地址、收货人联系电话），同时该订单包括具体订单号、订单创建时间、支付时间及应付金额、支付方式、您的备注信息。安徽省大好信息咨询有限公司收集这些信息是为了帮助您查询订单信息、提供客服与售后服务及其他安徽省大好信息咨询有限公司明确告知的目的。</span
      >
    </p>

    <p>
      <span
        >如您通过大好婚礼下单为他人订购商品及/或服务，您需要提供该实际订购人的上述信息并确保已经取得其他人的同意。</span
      >
    </p>

    <p>
      <span>您可以通过“我的-我的订单-全部订单”查看和管理您的订单信息。</span>
    </p>

    <p>
      <span
        >2.2.11
        订单支付相关信息：为了完成订单支付，您需要选择从支付宝支付、云闪付、微信支付中选择付款方式。安徽省大好信息咨询有限公司会将订单支付相关信息、银行卡号、有效期在内的银行卡支付必要信息、订单安全相关设备信息及其他法律要求的必要信息通过在应用程序中嵌入的软件工具开发包 方式与您选择的对应的支付宝、云闪付、微信支付机构共享。安徽省大好信息咨询有限公司收集这些信息是为了使安徽省大好信息咨询有限公司及时获悉并确认您的支付进度及状态，为您提供售后与争议解决服务。</span
      >
    </p>
    <p>
      <span
        >2.2.12
        商品或服务的交付信息：您知晓并同意相应的物流配送主体同步大好婚礼相关的配送信息。安徽省大好信息咨询有限公司将会收集您订购商品及/或商品的物流信息是为了及时获悉并确认交付进度与状态，向您提供售后与争议解决服务。</span
      >
    </p>
    <p>
      <span
        >2.2.13
        客服与争议处理：当您与安徽省大好信息咨询有限公司联系或提出售前、售中、售后争议纠纷处理申请时，为了保障您的账户与系统安全，安徽省大好信息咨询有限公司需要您提供必要的个人信息以验证您的身份。为便于与您联系、尽快帮助解决问题或记录相关问题的处理过程、方案及结果，安徽省大好信息咨询有限公司 会保存您与安徽省大好信息咨询有限公司的沟通记录（包括大好婚礼平台内交流、通信/通话记录方式及内容包括账户信息、订单信息、您为了证明事实提供的信息、您的联系方式信息）。如果您针对某个具体订单进行咨询、投诉或建议的，安徽省大好信息咨询有限公司还会使用您的账户信息和具体的订单信息。为了改进服务的合理需要，安徽省大好信息咨询有限公司还 使用您与客服人员联系时提供的相关信息，您参加问卷调查活动时向安徽省大好信息咨询有限公司发送的回复信息。</span
      >
    </p>
    <p>
      <strong>（三）为您提供评论、回答 发布公开信息功能</strong>
    </p>
    <p>
      <span
        >2.2.14
        您的发布信息。您可通过安徽省大好信息咨询有限公司为您提供评论、问答、及其他信息发布功能公开发布信息，</span
      ><strong
        >请注意：您公开发布的信息中 会涉及您或他人的个人信息，请您谨慎考虑，是否在使用安徽省大好信息咨询有限公司服务时公开分享相关信息。如您公开发布信息中涉及他人个人信息的，应当在发布前征得他人的同意。</strong
      ><span>安徽省大好信息咨询有限公司 会根据您的</span>
    </p>
    <p>
      <span
        >会员类型、网络日志信息判断及您提供的相关信息判断您是否可享受对应功能权限（例如，只有曾购买过某商家商品或服务的会员才能评论该商家。）</span
      >
    </p> -->
    <p>
      <strong>（二）为您提供安全保障</strong>
    </p>
    <p>
      <strong>1.2.5 </strong
      ><span
        >为提高您使用安徽省大好信息咨询有限公司提供的服务的安全性，更准确地预防虚假APP欺诈和木马病毒，安徽省大好信息咨询有限公司
        会使用或整合您的个人信息以及安徽省大好信息咨询有限公司的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息
        来综合判断您的账号及交易风险，包括验证身份，预防、发现、调查 存在的欺诈、网络病毒、网络攻击
        安全风险以及违反安徽省大好信息咨询有限公司或关联方协议、政策或规则
        行为，以保护您、其他用户、安徽省大好信息咨询有限公司或关联方的合法权益，并记录一些安徽省大好信息咨询有限公司认为有风险的链接(“URL”)。对于
        涉及的不满14周岁的儿童个人信息，安徽省大好信息咨询有限公司进一步采取以下措施予以保障：</span
      >
    </p>
    <p>
      <span
        >（1）对于收集到的儿童个人信息，安徽省大好信息咨询有限公司除遵守本隐私政策关于用户个人信息的约定外，还会秉持正当必要、知情同意、目的明确、安全保障、依法利用的原则，严格遵循《儿童个人信息网络保护规定》
        法律法规的要求进行存储、使用、披露，且不会超过实现收集、使用目的所必须的期限，到期后安徽省大好信息咨询有限公司会对儿童个人信息进行删除或匿名化处理。</span
      >
    </p>
    <p>
      <span
        >（2）当您作为监护人为被监护的儿童选择使用安徽省大好信息咨询有限公司的相关产品及/或服务时，安徽省大好信息咨询有限公司
        需要向您收集被监护的儿童个人信息，用于向您履行相关服务之必要。在具体服务中需要向您收集儿童个人信息的，安徽省大好信息咨询有限公司会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受安徽省大好信息咨询有限公司提供的相关服务。此外，您在使用晒单、评价及问答功能分享商品相关信息时
        会主动向安徽省大好信息咨询有限公司提供儿童个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，保护儿童个人信息安全。若儿童本人需要注册或使用安徽省大好信息咨询有限公司的产品与/或服务，您应正确引导并予以监护。</span
      >
    </p>
    <p>
      <span
        >（3）儿童或其监护人有权随时访问和更正儿童个人信息，还可以向安徽省大好信息咨询有限公司提出更正和删除的请求。如您对儿童个人信息相关事宜有任何意见、建议或投诉、举报，请联系安徽省大好信息咨询有限公司。安徽省大好信息咨询有限公司会随时为您提供帮助。</span
      >
    </p>

    <p>
      <span>1.2.6 其他用于为您服务需要收集的信息（具体收集时将予以告知）。 </span>
    </p>
    <p><strong>（五）其他功能</strong></p>
    <p>
      <span
        >1.2.7 您在使用“大好婚礼”平台电子请帖功能时，可以上传您与您伴侣的照片、文字描述、真实婚期、婚礼举办地点
        信息以制作电子请帖。</span
      >
    </p>
    <p>
      <span>1.2.8您在使用结婚账本功能时，可以上传您相关照片以记录相关数据。</span>
    </p>
    <p>
      <strong
        >1.2.9基于位置信息的发现服务：为了便捷您发现周边的婚纱摄影、酒店、婚礼策划
        生活服务信息，大好婚礼系统将会在您开启位置权限后访问您的位置信息，基于您的地理位置为您提供服务（LBS）。当您开启设备定位功能并使用大好婚礼的LBS时，大好婚礼系统会自动收集和使用您的位置信息，以实现大好婚礼为您提供本地周边生活服务的目的（如您不需要手动输入自身地理位置就可获得相关服务，以及估算商家与您之间的实际距离方便您进行消费决策）。大好婚礼系统对您的实际位置进行定位，包括
        IP 地址、GPS 以及能够提供相关信息的Wi-Fi 接入点、蓝牙和基站
        传感器技术。大好婚礼特别声明，此类定位信息收集使用，完全是系统条件操作，大好婚礼已采取严格的技术手段措施，杜绝
        用于为您提供前述服务以外的其他不当用途。</strong
      >
    </p>
    <p>
      <strong
        >1.2.10基于相机/摄像头的服务：您可以开启相机/摄像头权限后使用该功能进行扫码用于进入购买链接，拍摄照片或视频用于评价、分享、结婚账本、
        功能。安徽省大好信息咨询有限公司在此承诺，即使您同意开启相机/摄像头权限，安徽省大好信息咨询有限公司也仅会在您主动拍摄、录制、扫码
        主动使用相机/摄像头时获取信息。</strong
      >
    </p>
    <p>
      <strong
        >1.2.11基于相册(图片库/视频库)的图片/视频访问及上传的服务:您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像、发表评论/分享、拍照购物或与客服沟通提供证明、制作电子请帖、婚礼MV、结婚账本
        功能。安徽省大好信息咨询有限公司
        会通过您所上传的照片/图片来识别您需要购买的商品或服务，或使用包含您所上传照片或图片的评论信息。</strong
      >
    </p>
    <p>
      <strong
        >1.2.12基于麦克风的语音技术的服务:您可在开启麦克风权限后使用麦克风实现与客服联系或与客服机器人实现语音交互、制作电子请帖，安徽省大好信息咨询有限公司会收集您的录音内容以识别您的诉求,响应您的客服及争议处理需求或形成电子请帖语音部分。安徽省大好信息咨询有限公司承诺即使您已同意开启麦克风权限，安徽省大好信息咨询有限公司也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。</strong
      >
    </p>
    <p>
      <strong
        >1.2.13基于存储权限的服务:安徽省大好信息咨询有限公司向您申请获取此权限,目的是为了保障客户端的稳定运行。在您开启安徽省大好信息咨询有限公司可读取/写入您设备存储的权限后，安徽省大好信息咨询有限公司将自您设备存储空间内读取或向其中写入图片、文件、崩溃日志信息
        必要信息，用于向您提供信息发布或在本地记录崩溃日志信息 功能。</strong
      >
    </p>
    <!-- <p>
      <span
        >1.2.14基于电话状态的服务:安徽省大好信息咨询有限公司读取您的电话状态是为了保障您的账户与使用安全，向您展示您 感兴趣的信息，当您开启此权限后安徽省大好信息咨询有限公司会读取您的设备识别码或者广告标识符。您理解并同意，上述服务 需要您在您的设备中开启您的位置信息(地理位置)、摄像头(相机)、相册(图片库)、麦克风(语音)、通讯录、日历及/或电话状态的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置中逐项查看上述权限的状态,并可自行决定这些权限随时的开启或关闭。</span
      >
    </p> -->
    <p>
      <strong
        >请您注意：您开启任一权限即代表您授权安徽省大好信息咨询有限公司可以收集和使用相关个人信息来为您提供对应服务,您一旦关闭任一权限即代表您取消了授权，安徽省大好信息咨询有限公司将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</strong
      >
    </p>

    <p>
      <strong>1.3 收集和使用个人信息的其他规则</strong>
    </p>
    <p>
      <strong
        >1.3.1
        如您提供的信息中含有其他人的个人信息,在向大好婚礼提供这些个人信息之前，您需确保您已经取得合法的授权。</strong
      >
    </p>
    <p>
      <strong
        >1.3.2
        如安徽省大好信息咨询有限公司将信息用于本隐私权政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，均会事先获得您的同意。</strong
      >
    </p>
    <p>
      <span
        >1.3.3
        如安徽省大好信息咨询有限公司从第三方处间接获取您的信息，安徽省大好信息咨询有限公司会在收集前明确要求该第三方说明其个人信息来源，以及是否已经就其收集、处理以及向安徽省大好信息咨询有限公司提供您的个人信息取得了您的合法授权。除法律明确允许的情形外，安徽省大好信息咨询有限公司只会在确认第三方已经取得您的授权同意后再从第三方收集您的个人信息，如果第三方的授权范围无法涵盖安徽省大好信息咨询有限公司的处理和使用目的时，安徽省大好信息咨询有限公司会自行或者要求该第三方征得您的同意后再行处理您的个人信息。安徽省大好信息咨询有限公司会使用不低于安徽省大好信息咨询有限公司对自身用户个人信息同
        的保护手段与措施对间接获取的个人信息进行保护。</span
      >
    </p>
    <p><strong>3、用户信息的管理</strong></p>
    <p>
      <strong>2.1 未经您本人允许，大好婚礼不会向任何第三方披露您的用户信息，但下列情形除外：</strong>
    </p>
    <p>
      <span>2.1.1 大好婚礼已经取得您或您监护人的授权；</span>
    </p>
    <p>
      <span>2.1.2 司法机关或行政机关给予法定程序要求大好婚礼披露的；</span>
    </p>
    <p>
      <span>2.1.3 大好婚礼为维护自身合法权益而向用户提起诉讼或仲裁时；</span>
    </p>
    <p>
      <span>2.1.4 从合法公开披露的信息中收集个人信息的，如政府信息公开、合法的新闻报道 渠道；</span>
    </p>
    <p>
      <span>2.1.5 您自行向社会公众公开的个人信息； </span>
    </p>
    <p>
      <span>2.1.6 用于维护所提供的产品或服务的安全稳定运行所必需的；</span>
    </p>
    <p>
      <span
        >2.1.7
        用于公共利益开展统计或学术研究所必需，但对外提供统计或学术研究结果时应当对所包含的用户信息进行去标识化处理；
      </span>
    </p>
    <p>
      <span>2.1.8 出于维护您或其他个人的生命、财产 重大合法权益但又很难得到本人同意的； </span>
    </p>
    <p>
      <span>2.1.9 根据您与大好婚礼相关服务条款、应用许可使用协议的约定； </span>
    </p>
    <p>
      <span>用于维护所提供的产品及/或服务的安全稳定运行所必需的，如发现、处置产品及/或服务的故障；</span>
    </p>
    <p>
      <span
        >2.1.10
        为您提供您需要的产品或服务必要的情况下披露:您通过大好婚礼平台购买商品或服务，安徽省大好信息咨询有限公司会根据您的选择，将您订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易、配送及售后服务需求。</span
      >
    </p>
    <!-- <p>
      <strong
        >2.1.11
        为便于安徽省大好信息咨询有限公司基于大好婚礼账户向您提供产品和服务,推荐您 感兴趣的信息,识别会员账户异常,保护大好婚礼关联公司或其他用户或公众的人身财产安全免遭侵害，安徽省大好信息咨询有限公司 会披露您的个人信息给安徽省大好信息咨询有限公司的关联公司和/或其指定的服务提供商。安徽省大好信息咨询有限公司只会共享必要的个人信息，且受本隐私政策中所声明目的的约束,如果安徽省大好信息咨询有限公司共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</strong
      >
    </p> -->
    <p>
      <span>2.1.12 法律法规规定的其他情形。 </span>
    </p>
    <p>
      <span
        >2.2
        若安徽省大好信息咨询有限公司对个人信息釆取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原或安徽省大好信息咨询有限公司
        会对收集的信息进行去标识化地研究、统计分析和预测，用于改善大好婚礼的内容和布局，为商业决策提供产品或服务支撑，以及改进安徽省大好信息咨询有限公司的产品和服务(包括使用匿名数据进行机器学习或模型算法训练)，</span
      ><strong>则此类处理后数据的使用无需另行向您通知并征得您的同意。</strong>
    </p>
    <p>
      <strong
        >2.3 安徽省大好信息咨询有限公司
        委托授权合作伙伴为您提供某些服务或代表安徽省大好信息咨询有限公司履行职能,安徽省大好信息咨询有限公司仅会出于本隐私权政策声明的合法、正当、必要、特定、明确的目的披露您的个人信息，授权合作伙伴只能接触到其履行职责所需信息，且安徽省大好信息咨询有限公司将会通过协议要求其不得将此信息用于其他任何目的。</strong
      ><span>安徽省大好信息咨询有限公司的授权合作伙伴包括以下类型：</span>
    </p>
    <!-- <p>
      <span
        >2.3.1
        广告、分析服务类的授权合作伙伴。安徽省大好信息咨询有限公司会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但除非得到您的许可，否则安徽省大好信息咨询有限公司不会披露您的个人身份信息，或者安徽省大好信息咨询有限公司会将这些信息进行去标识化处理，以便授权合作伙伴无法识别您个人。这类合作伙伴 将上述信息与他们合法获取的其他数据相结合，以执行安徽省大好信息咨询有限公司委托的广告服务或决策建议。</span
      >
    </p> -->
    <p>
      <span
        >2.3.1
        供应商、服务提供商和其他合作伙伴。安徽省大好信息咨询有限公司将信息发送给支持安徽省大好信息咨询有限公司业务的供应商、服务提供商和其他合作伙伴,这些支持包括受安徽省大好信息咨询有限公司委托提供的技术基础设施服务、分析安徽省大好信息咨询有限公司服务的使用方式、提供客户服务、支付便利或进行学术研究和调查。</span
      >
    </p>
    <p>
      <span
        >2.4
        如安徽省大好信息咨询有限公司停止运营大好婚礼产品或服务，安徽省大好信息咨询有限公司将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对安徽省大好信息咨询有限公司所持有的与已关停业务相关的个人信息进行删除或匿名化处理。涉及儿童个人信息的，安徽省大好信息咨询有限公司会并将停止运营的通知及时告知儿童监护人。</span
      >
    </p>
    <p>
      <span
        >2.5
        在大好婚礼服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，安徽省大好信息咨询有限公司会要求新的持有您个人信息的公司、组织继续受本隐私权政策的约束，否则安徽省大好信息咨询有限公司将要求该公司、组织和个人重新向您征求授权同意。</span
      >
    </p>
    <p>
      <span>2.6 安徽省大好信息咨询有限公司仅会在以下情况下，公开披露您的个人信息：</span>
    </p>
    <p>
      <span>2.6.1 获得您明确同意或基于您的主动选择，安徽省大好信息咨询有限公司 会公开披露您的个人信息；</span>
    </p>
    <p>
      <strong
        >2.6.2
        如果安徽省大好信息咨询有限公司确定您出现违反法律法规或严重违反大好婚礼平台相关协议及规则的情况，或为保护大好婚礼平台用户或公众的人身财产安全免遭侵害，安徽省大好信息咨询有限公司
        依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及大好婚礼平台已对您采取的措施。</strong
      ><span
        >例如，若您严重违反大好婚礼规则，安徽省大好信息咨询有限公司 会公开披露您的店铺认证主体信息与违规处罚情况。</span
      >
    </p>
    <p><strong>3、用户信息保护措施</strong></p>
    <p>
      <span
        >3.1
        大好婚礼谨遵法律规定，承担对您个人信息的保护义务，采取必要措施不会泄露、篡改、毁损您的个人信息；除依照法律规定和双方约定外，未经您的同意，大好婚礼不会将您的个人信息透露给任何第三人。
      </span>
    </p>
    <p>
      <span
        >3.2
        为防止用户信息在意外的、未经授权的情况下被非法访问、复制、修改、传送、遗失、破坏、处理或使用，大好婚礼采取的措施包括：</span
      >
    </p>
    <p>
      <span>3.2.1 以适当的方式对用户的个人信息进行<strong>加密处理；</strong></span>
    </p>
    <p>
      <span>3.2.2 在适当的位置使用密码对用户个人信息进行保护 </span>
    </p>
    <p>
      <span>3.2.3 限制对用户个人信息的访问； </span>
    </p>
    <p>
      <span>3.2.4 其他必要的合理措施。</span>
    </p>
    <p>
      <span
        >3.3
        用户信息的保护，不仅大好婚礼应当采取必要措施，履行法律义务，用户自己也要承担相应责任，包括并不限于采取诸如定期修改帐号密码、加大密码设置的安全性，不将自己的帐号密码
        用户信息透露给他人 安全措施。</span
      >
    </p>
    <p>
      <strong
        >3.4
        您知悉：大好婚礼提供的用户信息保护措施仅适用于大好婚礼平台，一旦您离开大好婚礼，浏览或使用其他网站、服务及内容资源，大好婚礼即没有能力及义务保护您在大好婚礼以外的网站提交的任何用户信息，无论您登陆或浏览上述网站是否基于大好婚礼的链接或引导。</strong
      >
    </p>
    <p>
      <strong>4、安徽省大好信息咨询有限公司如何使用Cookie及同类技术</strong>
    </p>
    <p>
      <span
        >4.1
        Cookie可以帮助网站辨认注册用户，计算用户数量，通常被各网站用来判定完成注册的用户是否已经实现登录。大好婚礼承诺，对cookie信息的研究仅用于提升服务/产品质量及优化用户体验之目的。同时，您如不希望用户信息保留在cookie中，您可以对浏览器进行配置：选择“拒绝cookie”或“当网站发送cookie时通知您”，您知道，鉴于大好婚礼的服务是通过支持cookie来是实现的，完成关闭cookie的操作后，
        影响到您访问大好婚礼或不能充分取得大好婚礼的服务。您不禁用cookie时，
        会得到提示：是否在下一次进入此网站时保留用户信息以便简化登录手续（如一键登录）。</span
      >
    </p>
    <p>
      <span
        >4.2 除Cookie外，安徽省大好信息咨询有限公司还会在网站上使用web beacon
        同类技术，其方法和目的与cookie是相同的。</span
      >
    </p>
    <p>
      <strong
        >大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。</strong
      >
    </p>
    <p><strong>4.3 SDK的使用</strong></p>
    <p>
      为保障安徽省大好信息咨询有限公司客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，安徽省大好信息咨询有限公司的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序，安徽省大好信息咨询有限公司接入授权合作伙伴的SDK详情如下：
    </p>
    <p>
      <span style="color: rgb(34, 34, 34)"
        >安徽省大好信息咨询有限公司接入的SDK详情。安徽省大好信息咨询有限公司会对获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，执行严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。</span
      >
    </p>

    <p>
      <span style="color: rgb(34, 34, 34)"
        >本政策仅适用于安徽省大好信息咨询有限公司及其相关服务。
        您的个人信息安全对我们来说至关重要，一直以来，我们都尽全力保护您的个人信息安全，致力于维持您对我们的信任。我们将依据相关法律法规和技术规范收集和使用您的个人信息，以帮助我们向您提供更优质的产品和服务。同时，我们承诺会对您的个人信息和其他数据进行严格保密，确保您的个人信息安全。
        请在使用我们的产品和服务前，仔细阅读本隐私政策。一旦您开始使用安徽省大好信息咨询有限公司产品及相关服务，即表示您同意本政策。</span
      >
    </p>
    <p>
      安徽省大好信息咨询有限公司会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格旳数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。
    </p>
    <p>4.4 <strong>自启动</strong>和关联启动说明</p>
    <p>极光SDK具有<strong>自启动</strong>功能，为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，将存在一定频率通过系统发送广播唤醒本应用<strong>自启动</strong>或关联启动行为,是因实现功能及服务所必要的。本应用须使用(<strong>自启动</strong>)能力，其目的是确保推送通道的稳定性，以便正常及时地向安卓设备推送消息。当系统发送广播时，将唤醒极光SDK<strong>自启动</strong>行为。鉴于极光SDK系以集成方式接入应用，极光SDK<strong>自启动</strong>，则应用亦随之<strong>自启动</strong>。该行为系因实现推送功桎犯及服务所必要</p>
    <p>为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(<strong>自启动</strong>)能力，将存在一定频率通过系统发送广播唤醒本应用<strong>自启动</strong>或关联启动行为，是因实现功能及服务所必要的。</p>
    <p>（1）在征得您的明确同意后，会跳转大好婚礼APP打开相关内容。在未征得您同意的情况下，则不会有关联启动。</p>
    <p>（2）您可以在“设置”中关闭“接收新消息通知”开关，这样会同时关闭推送服务。当您再次开启此开关时，也会重启推送服务。如您想关掉<strong>自启动</strong>功能，可能会导致无法正常提醒。您可以在设置-应用-<strong>自启动</strong>管理中关闭<strong>自启动</strong>功能。</p>
    <p>（3）当您打开本App内部分享功能后，会启动第三方App</p>

    <p>
      <strong>5、您如何管理您的信息</strong>
    </p>
    <p>
      <strong>5.1 查询、更正和补充您的信息</strong>
    </p>
    <p>
      <span>您有权查询、更正或补充您的信息。您可以通过以下方式自行进行:</span>
    </p>
    <p>
      <span
        >5.1.1
        登录大好婚礼客户端,进入“安徽省大好信息咨询有限公司-设置”对个人信息、账号信息、伴侣主页信息进行查询、更正或补充；</span
      >
    </p>
    <p>
      <span>5.1.2 登录大好婚礼或大好婚礼客户端并选择联系客服寻求帮助,协助您查询、更正或补充您的信息。 </span>
    </p>
    <p><strong>5.2 删除您的信息</strong></p>
    <p>
      <span>5.2.1 您可以通过”5.1查询、更正和补充您的信息”中列明的方式删除您的部分信息。 </span>
    </p>
    <p>
      <span>5.2.2 在以下情形中，您可以通过与大好婚礼客服联系向安徽省大好信息咨询有限公司提出删除个人信息：</span>
    </p>
    <p>
      <span>（1）如果安徽省大好信息咨询有限公司处理个人信息的行为违反法律法规；</span>
    </p>
    <p>
      <span>（2）如果安徽省大好信息咨询有限公司收集、使用您的个人信息,却未征得您的明确同意；</span>
    </p>
    <p>
      <span>（3）如果安徽省大好信息咨询有限公司处理个人信息的行为严重违反了与您的约定;</span>
    </p>
    <p>
      <span>（4）如果您主动注销了账户。</span>
    </p>
    <p>
      <span
        >如安徽省大好信息咨询有限公司决定响应您的删除请求，安徽省大好信息咨询有限公司还将同时尽
        通知从安徽省大好信息咨询有限公司处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。</span
      ><strong
        >当您或安徽省大好信息咨询有限公司协助您删除相关信息后，因为适用的法律和安全技术限制，安徽省大好信息咨询有限公司
        无法立即从备份系统中删除相应的信息，安徽省大好信息咨询有限公司将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份可以清除或实现匿名化。</strong
      >
    </p>
    <p><strong>5.3 改变您的授权范围</strong></p>
    <p>
      <span>5.3.1 您可以通过改变您的智能移动设备的设置 方式给予、修改或收回您的授权范围。</span>
    </p>
    <p>
      <span
        >5.3.2
        对于您无法直接通过上述方式设置的授权，您可以通过与大好婚礼客服联系进行修改，对于部分类型的个人信息，例如实现大好婚礼基本功能所必须的信息或者安徽省大好信息咨询有限公司履行法律法规规定的义务所必需的信息，安徽省大好信息咨询有限公司
        没有办法响应您改变授权范围的请求。
      </span>
    </p>
    <p>
      <span>当您改变授权范围同后，安徽省大好信息咨询有限公司将不再处理相应的个人信息。</span
      ><strong
        >但您上述改变授权范围的决定，不会影响安徽省大好信息咨询有限公司此前基于您的授权而开展的个人信息处理。</strong
      >
    </p>
    <p><strong>5.4 注销您的账户</strong></p>

    <p>
      <span style="color: rgb(34, 34, 34)"
        >请您在申请注销流程前，务必仔细阅读，充分理解本《注销须知》
        <p>【温馨提示】</p>
        您注销账号的行为，将导致大好婚礼系列产品，包括但不限于大好婚礼网页版
        均无法继续为您提供服务，您亦无法继续使用该账号。

        <p>5.4.1&nbsp;一.注销条件</p>

        <p>
          请您在注销账号前，确保账号符合以下全部条件，否则，您 无法正常完成注销流程，且需要承担由此产生的全部损失和责任:
        </p>
        <p>1,账号未被采取任何进行中的限制措施，包括但不限于未完成的违规处罚或权限记录;</p>
        <p>2.账号下无未解决纠纷，包括但不限于投诉、举报、诉讼 ;</p>
        <p>3.您已就账号内的信息自行备份留存;</p>
        <p>4.您应确保您有权决定该账号的注销事宜;</p>
        <p>5.您应承诺该账号注销申请提交后，不会以任何理由要求撤销;</p>
        <p>6.您应确保您注销该账号的行为不侵犯任何第三方的合法权益，如因此引发任何投诉争议，由您自行承担。</p>
        <p>5.4.2&nbsp;二.注销结果</p>
        <p>
          1.账号一旦被注销将不可恢复。账号被注销后，您将无法在大好婚礼系列产品上登录、使用该账号;如您在注销后需要再次使用我们的服务，您可以重新注册。
        </p>
        <p>2.账号被注销后，该账号在大好婚礼系列产品上的全部数据资料，包括但不限于个人信息、收藏内容 都将无法找回。</p>
        <p>
          3.账号被注销后，该账号在大好婚礼系列产品上获得的账号会员权益、资格、及其他权益
          视为您自行放弃，将无法继续使用。
        </p>
        <p>4.账号被注销后，您通过该账号授权登录或绑定其他账号，您将无法再登录使用。</p>
        <p>
          5,根据相关法律法规规定，我们仅会在实现目的所必须的最短时间内留存您的相关个人信息。在您主动注销账号时，大好婚礼系列产品的运营主体及关联公司将根据法律法规的要求尽快删除您的个人信息或匿名化处理。
        </p>
        <p>6.注销账号，并不代表该账号注销前的行为及责仟能够得到豁免或减轻。</p>
        <p>5.4.3&nbsp; 三.联系我们</p>
        如您对本须知有任何疑问，可联系平台客服进行咨询，客服将在收到您的需求后15日内予以回复。；联系电话4000-996-966
      </span>
    </p>

    <p>注销账号:我的-设置-注销账号</p>
    <p style="color: rgb(34, 34, 34)">
      登录大好网站或登录手机大好客户端并选择联系客服，寻求帮助，客服将详细记录您的需求，并承诺于您提出申请起15个工作日内完成核查及处理，协助您申请注销您的账户。在您主动注销账户之后，安徽省大好信息咨询有限公司将停止为您提供产品或服务，并根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。
    </p>
    <p>
      <strong
        >5.5
        当您向安徽省大好信息咨询有限公司提出上述管理信息的请求时，安徽省大好信息咨询有限公司将在15天内作出答复。</strong
      >
    </p>
    <p>
      <strong>6、未成年人的用户注册</strong>
    </p>
    <p>
      <span
        >6.1
        大好婚礼平台主要面向成年人，申请注册为大好婚礼用户或者大好婚礼商家的，原则上应当是成年人（含十六周岁以上，以自己的劳动收入为主要生活来源的自然人），</span
      ><strong>如您在大好婚礼上申请注册账号，安徽省大好信息咨询有限公司推定您具有相应的民事行为能力。</strong>
    </p>
    <p>
      <span>6.2 若您是18周岁以下的未成年人，在使用大好婚礼的服务前，应确保事先取得监护人的同意，</span
      ><strong>如您在大好婚礼上申请注册账号，大好婚礼将默认为您已得到前述同意。</strong>
    </p>
    <p>
      <span
        >6.3
        若您是儿童的父母或其他监护人,请您关注您监护的儿童是否是在取得您的授权同意之后使用安徽省大好信息咨询有限公司的服务的。如您对您所监护的儿童的个人信息有疑问，通过与大好婚礼客服取得联系向安徽省大好信息咨询有限公司反馈。</span
      >
    </p>
    <p>
      <span>6.4 对未成年人的用户信息，大好婚礼将依照法律规定，予以严格保护。</span>
    </p>
    <p><strong>7、本规则的名词解释</strong></p>
    <p>
      <span
        >7.1
        “大好婚礼”，是指大好婚礼电子商务平台向用户提供功能使用和服务的产品载体（主页www.dahaohunli.com,域名pms.dahaoxiaoxi.com，包括但不限于APP移动平台、网站
        ），大好婚礼运营商和服务的提供者为安徽省大好信息咨询有限公司。
      </span>
    </p>
    <p>
      <span>7.2 “大好婚礼用户”，是指在大好婚礼平台注册接受大好婚礼服务的自然人（消费者）； </span>
    </p>
    <p>
      <span>7.3 “大好婚礼商家”，是指在大好婚礼平台注册从事婚礼服务或者婚品 商品销售的经营者。 </span>
    </p>
    <p>
      <span
        >7.4
        “用户信息”，是指大好婚礼用户或者大好婚礼商家的自然人信息，即以电子或者其他方式记录的能够单独或者与其他信息结合识别自然人个人身份的各种信息。</span
      >
    </p>
    <p>
      <span>7.5 “您”，是指大好婚礼用户或者大好婚礼商家。 </span>
    </p>

    <p><strong>8、本政策的更新</strong></p>
    <p>
      <span
        >安徽省大好信息咨询有限公司的隐私政策
        变更，未经您明确同意，安徽省大好信息咨询有限公司不会限制您按照本隐私政策所应享有的权利。对于重大变更，安徽省大好信息咨询有限公司还会在大好婚礼平台显著位置进行通知。</span
      >
    </p>

    <p>
      <strong>主体公司：安徽省大好信息咨询有限公司</strong>
    </p>
    <p>
      <strong>注册地址：安徽省阜阳市颍泉区水岸明珠31栋203室</strong>
    </p>
    <p>
      <strong>常用办公地址：安徽省阜阳市颍东区向阳路大好婚嫁产业园</strong>
    </p>
    <p>
      <strong>负责人联系电话：15955150029</strong>
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      msg: ''
    }
  },
  created() {
    document.title = '隐私协议'
  },
  methods: {
    SharedList() {
      this.$router.push({ path: '/thirdParty' })
    },
    behavior() {
      this.$router.push({ path: '/behavior' })
    },
    PersonalInformationList() {
      this.$router.push({ path: '/PersonalInformationList' })
    }
  }
}
</script>

<style scoped>
strong{
  color: #e4890a;
}
p.span {
  text-align: left;
  color: #343;
  word-break: break-all;
}
a {
  word-break: break-all;
}
h2 {
  text-align: left;
}
.SharedList {
  width: 18rem;
  height: 2rem;
  /* margin: 1rem auto; */
  font-size: 22px;
  line-height: 2rem;
  text-decoration: underline;
  /* text-align: center; */
  /* background-color: #1387f4; */
  color: #1387f4;
  border-radius: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue